import { isElectronApp } from "../../../common/utils/electronAppHelper";
import fireDb from "../../../api/firebase/realtime/utils";
import { relationToNodes } from "../components/main/displayArea/drawSnaLxt/drawNetwork/SNAutils";
// eslint-disable-next-line import/named
import { getSnaDataFromFileSever, getSnaDataFromLocal } from "./datasetService";

/* =========== user setting =========== */

export const getUserSettings = async (userId = "") => {
  try {
    if (isElectronApp()) {
      // todo: 取得 local 設定
      return {};
    }
    // 搜尋 firebase 找到對應的 userId 的 所有 file id
    if (!userId) return {};
    const data = await fireDb.getUserSettingOnce({ uid: userId });
    if (data instanceof Error) {
      return {};
    }
    return data;
  } catch (err) {
    return {};
  }
};

//
export const updateUserSettingsLocal = () => {};

//
export const updateUserSettings = async ({
  userId = "",
  data,
  onSuccess,
  onError,
}) => {
  try {
    if (isElectronApp()) {
      // todo: 取得 local 設定
      updateUserSettingsLocal();
    } else {
      fireDb.updateUserSetting({ uid: userId, data, onSuccess, onError });
    }
  } catch (err) {
    if (onError) onError(err);
  }
};

// 讀取個人檔案的資料
export const getPersonalDatasetSna = async (datasetPersonal) => {
  try {
    // 依據 web app / electron app 切換取得資料的方式
    const getDataFunc = isElectronApp()
      ? getSnaDataFromLocal
      : getSnaDataFromFileSever;

    const datasetPersonalChecked = (datasetPersonal || []).filter(
      (item) => item.checked
    );
    const apiQuery = [];
    datasetPersonalChecked.forEach((item) => {
      apiQuery.push(
        getDataFunc({
          ...item,
          datasetId: item?.uid,
          datasetName: item.displayName,
        })
      );
    });

    return Promise.all(apiQuery)
      .then((res) => {
        const totalRes = res.reduce((acc, cur) => [...acc, ...cur], []);
        // 轉換格式: relation 格式變成 nodes 格式
        return { data: relationToNodes(totalRes), error: null };
        // return relationToNodes(totalRes);
      })
      .catch((err) => ({ data: [], error: err.message }));
  } catch (err) {
    return { data: [], error: err.message };
  }
};
